import { render, staticRenderFns } from "./QueueDashboard.vue?vue&type=template&id=45438eb3&scoped=true&"
import script from "./QueueDashboard.vue?vue&type=script&lang=js&"
export * from "./QueueDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QueueDashboard.vue?vue&type=style&index=0&id=45438eb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45438eb3",
  null
  
)

export default component.exports